import { createSlice } from '@reduxjs/toolkit';
import { set } from 'lodash';
const initialState = {
    token: '',
    summaryCardData: null,
};
const slice = createSlice({
    name: 'receipt',
    initialState,
    reducers: {
        setToken: (state, action) => {
            set(state, 'token', action.payload);
        },
        setSummaryCardData: (state, action) => {
            set(state, 'summaryCardData', action.payload);
        },
    },
});
export const { setToken, setSummaryCardData } = slice.actions;
export default slice.reducer;
